'use strict';

import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("highchartConfigUpdater", function (stringUtils, highchartConfigBlocks) {
  var stripHtml = stringUtils.stripHtml;

  /**
   * Extract the editable pieces of a chart config and populate with the chart's current value.
   *
   * @param chartConfig
   */
  var getUpdaterParameters = function getUpdaterParameters(chartConfig) {
    var options = chartConfig.options,
      series = chartConfig.series;
    var parameters = {};
    var isPie = options.chart.type === 'pie';

    // title & subtitle
    parameters.title = stripHtml(options.title.text);
    parameters.subtitle = stripHtml(options.subtitle.text);

    // height / width
    parameters.width = isPie ? 800 : 1200;
    parameters.height = 400;

    // legend
    if (options.legend.enabled) {
      parameters.legend = options.legend.align === "right" ? "RIGHT" : "BOTTOM";
    } else {
      parameters.legend = "HIDDEN";
    }
    parameters.legendFloating = options.legend.floating === true ? 'true' : 'false';

    // series
    parameters.series = _.map(series, function (serie) {
      return {
        id: serie.id,
        name: serie.name || serie.id,
        color: serie.color,
        visible: true
      };
    });

    // pie chart specific
    if (isPie) {
      parameters.pie = {
        chartColors: options.colors,
        chartPieData: series[0].data,
        colorChartPieOnSerie: series[0].data[0]['color'] !== undefined
      };
      parameters.dataLabelsEnabled = true;
    }

    // data labels
    if (options.plotOptions && options.plotOptions.series && options.plotOptions.series.dataLabels) {
      parameters.dataLabelsEnabled = options.plotOptions.series.dataLabels.enabled;
    }

    // xAxis
    parameters.xAxis = _.map(options.xAxis, function (axis) {
      return {
        title: stripHtml(axis.title && axis.title.text || "")
      };
    });

    // yAxis
    parameters.yAxis = _.map(options.yAxis, function (axis) {
      return {
        title: stripHtml(axis.title && axis.title.text || "")
      };
    });
    return parameters;
  };
  var applyConfigUpdate = function applyConfigUpdate(chartConfig, updaterParams) {
    var options = chartConfig.options,
      series = chartConfig.series;

    // title
    options.title.text = updaterParams.title;
    options.subtitle.text = updaterParams.subtitle;

    // height / width
    options.chart.height = updaterParams.height;
    options.chart.width = updaterParams.width;

    // init plotOptions if missing
    if (!options.plotOptions) {
      options.plotOptions = {
        series: {},
        pie: {}
      };
    }
    options.plotOptions.series.animation = false;

    // series
    var filteredSeries = [];
    for (var i = 0; i < series.length; i++) {
      var serie = series[i];
      var serieOptions = updaterParams.series[i];
      if (!serieOptions.visible) {
        continue;
      }
      serie.color = serieOptions.color;
      filteredSeries.push(serie);
    }
    chartConfig.series = filteredSeries;

    // pie chart specific
    if (updaterParams.pie) {
      if (updaterParams.pie.colorChartPieOnSerie) {
        for (var _i = 0; _i < series[0].data.length; _i++) {
          series[0].data[_i].color = updaterParams.pie.chartPieData[_i].color;
        }
      } else {
        for (var _i2 = 0; _i2 < series[0].data.length; _i2++) {
          options.colors[_i2] = updaterParams.pie.chartColors[_i2];
        }
      }
    }

    // data labels
    if (updaterParams.dataLabelsEnabled != null) {
      _.each(chartConfig.series, function (serie) {
        serie.dataLabels.enabled = updaterParams.dataLabelsEnabled;
      });
    }

    // xAxis
    _.each(updaterParams.xAxis, function (axisConfig, i) {
      if (!options.xAxis[i].title) {
        options.xAxis[i].title = {};
      }
      options.xAxis[i].title.text = axisConfig.title;
    });

    // yAxis
    _.each(updaterParams.yAxis, function (axisConfig, i) {
      if (!options.yAxis[i].title) {
        options.yAxis[i].title = {};
      }
      options.yAxis[i].title.text = axisConfig.title;
    });

    // legend
    switch (updaterParams.legend) {
      case "HIDDEN":
        {
          options.legend.enabled = false;
          break;
        }
      case "RIGHT":
        {
          options.legend = _objectSpread({}, options.legend, {}, highchartConfigBlocks.legendOnRight);
          break;
        }
      case "BOTTOM":
        {
          options.legend = _objectSpread({}, options.legend, {}, highchartConfigBlocks.legendOnBottom);
          break;
        }
    }
    options.legend.floating = updaterParams.legendFloating === 'true' && updaterParams.legend === "RIGHT" ? true : false;
    // retire le marginRight qui bloque la position de la legende à droite
    options.chart.marginRight = undefined;
    if (options.chart.type === 'pie') {
      _.each(chartConfig.series, function (serie) {
        return serie.showInLegend = updaterParams.legend !== 'HIDDEN';
      });
    }
    return chartConfig;
  };
  return {
    getUpdaterParameters: getUpdaterParameters,
    applyConfigUpdate: applyConfigUpdate
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/highcharts/exporter/highcharts-config-updater.js
// module id = 2957
// module chunks = 13